/**
 * Uruguay Peso en Unidades Indexadas.
 */
export var UYI = {
  code: 'UYI',
  base: 10,
  exponent: 0
};